import React from 'react';
import SubNavigationCollapsible from './SubNavigationCollapsible';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { SubNavigationLinkModel } from '../../Types/SubNavigationLinkModel';

const StyledSecondLevelNavigationList = styled.ul`
  > li {
    background-color: ${getColor('white')};
    &:not(:last-child) {
      border-bottom: 1px solid ${getColor('gray', 300)};
    }
    &.has-children {
      border-bottom: none;
    }
    a {
      height: 40px;
      display: flex;
      align-items: center;
      padding-left: 1.2rem;
      ${text('medium')};
      &:hover {
        background-color: ${getColor('gray', 100)};
      }
    }
  }
  .collapsible {
    border-top: none !important;
    border-bottom: none !important;
  }
  li.is-selected {
    background: ${getColor('gray', 100)};
    a {
      ${fontFamilyBold}
    }
  }
`;
const StyledNavigationList = styled.ul`
  .title {
    background-color: ${getColor('white')};
    a {
      text-transform: uppercase;
      ${fontFamilyBold};
    }
  }
  border-radius: 0 0 4px 4px;
  overflow: hidden;
  border-top: 1px solid ${getColor('gray', 300)};
  ${breakpoint('medium')} {
    border-radius: 4px;
    border: 1px solid ${getColor('gray', 300)};
    margin-bottom: 1.6rem;
  }

  > li {
    &:not(:last-child) {
      border-bottom: 1px solid ${getColor('gray', 300)};
    }
    a {
      height: 40px;
      display: flex;
      align-items: center;
      padding-left: 1.2rem;
      ${text('medium')};
      ${fontFamilyBold}
      &:hover {
        background-color: ${getColor('gray', 100)};
      }
    }
  }
`;
const SubNavigation = ({ links, name, url }: SubNavigationLinkModel) => {
  return (
    <StyledNavigationList>
      <li className="title">
        <a href={url}>{name}</a>
      </li>
      {links.length >= 1 && (
        <StyledSecondLevelNavigationList>
          {links.map((link, idx) =>
            link.links.length >= 1 ? (
              <li className="has-children" key={link.name + link.url + idx}>
                <SubNavigationCollapsible
                  isSelected={link.isSelected}
                  isOpen={
                    link.isSelected ||
                    link.links.some((l) => l.isSelected == true)
                  }
                  label={
                    <a
                      className={link.isSelected ? 'is-selected' : undefined}
                      href={link.url}
                    >
                      {link.name}
                    </a>
                  }
                >
                  <ul>
                    {link.links.map((secondLevelLink, idx) => (
                      <li
                        className={
                          secondLevelLink.isSelected ? 'is-selected' : undefined
                        }
                        key={secondLevelLink.name + idx}
                      >
                        <a href={secondLevelLink.url}>{secondLevelLink.name}</a>
                      </li>
                    ))}
                  </ul>
                </SubNavigationCollapsible>
              </li>
            ) : (
              <li
                className={link.isSelected ? 'is-selected' : undefined}
                key={link.name + idx}
              >
                <a href={link.url}>{link.name}</a>
              </li>
            )
          )}
        </StyledSecondLevelNavigationList>
      )}
    </StyledNavigationList>
  );
};

export default SubNavigation;
